var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container public"},[_c('div',{staticClass:"row justify-content-center"},[_c('b-card',{staticClass:"col-lg-4",attrs:{"border-variant":"warning","header":"Сообщение для пользователя","header-bg-variant":"transparent","align":"center"}},[_c('b-card-text',[_vm._v(_vm._s(_vm.msg))])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }